import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  --teal-900: #115e59;
  --teal-600: #0f766e;
  --teal-400: #0f766e;
  --teal-200: #5eead4;
  --teal-100: #ccfbf1;
  --teal-50: #ecfdf5;
  --blue-50: #E6F1FB;
  --blue-800: #0C447C;
  --blue-border: #B5D4F4;
  --green-50: #EAF3DE;
  --green-600: #3B6D11;
  --green-border: #C0DD97;
  --amber-50: #FAEEDA;
  --amber-600: #854F0B;
  --red-800: #A32D2D;
  --page-bg: #f6f8fb;
  --panel-bg: #ffffff;
  --bg-secondary: #f8fafc;
  --text-primary: #111827;
  --text-secondary: #5b6472;
  --text-tertiary: #8a94a6;
  --border: #e5e7eb;
  --border-soft: #edf0f3;
  display: block;
  min-height: 100%;
  background: var(--page-bg);
}

button {
  font: inherit;
}

.dashboard-page {
  min-height: 100%;
  background: var(--page-bg);
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
}

.hero-banner {
  padding: 28px 32px 0;
  border-bottom: 1px solid var(--border);
  background: var(--teal-600);
  color: #ffffff;
}

.hero-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 26px;
}

.hero-copy {
  min-width: 0;
}

.hero-eyebrow {
  color: var(--teal-100);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
}

.hero-copy h1 {
  margin: 4px 0 0;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
}

.hero-copy p {
  margin: 7px 0 0;
  color: var(--teal-100);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.hero-action {
  min-height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  border: 0.5px solid rgba(255, 255, 255, 0.28);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.hero-action.ghost {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.hero-action.solid {
  border-color: #ffffff;
  background: #ffffff;
  color: var(--teal-600);
}

.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 0.5px solid rgba(255, 255, 255, 0.22);
}

.kpi-cell {
  min-height: 126px;
  padding: 18px 24px;
  border: 0;
  border-right: 0.5px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: inherit;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: default;
}

.kpi-cell:last-child {
  border-right: 0;
}

button.kpi-cell {
  cursor: pointer;
}

.kpi-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--teal-100);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.kpi-eyebrow i {
  color: var(--teal-100);
  font-size: 11px;
}

.kpi-value {
  margin-top: 8px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.kpi-value.accent {
  color: var(--teal-100);
}

.kpi-helper {
  margin-top: 7px;
  color: var(--teal-100);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
}

.kpi-progress {
  width: 100%;
  height: 3px;
  margin-top: 14px;
  background: rgba(255, 255, 255, 0.22);
  overflow: hidden;
}

.kpi-progress-fill {
  height: 100%;
  background: #ffffff;
}

.dashboard-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(300px, 320px);
  background: var(--page-bg);
}

.dashboard-column {
  min-width: 0;
  padding: 20px;
  border-right: 0.5px solid var(--border);
}

.dashboard-column:last-child {
  border-right: 0;
}

.panel {
  border: 0.5px solid var(--border);
  border-radius: 12px;
  background: var(--panel-bg);
  overflow: hidden;
}

.panel + .panel {
  margin-top: 14px;
}

.panel-head {
  min-height: 58px;
  padding: 14px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 0.5px solid var(--border-soft);
}

.panel-head.compact {
  min-height: 52px;
}

.section-eyebrow {
  display: block;
  color: var(--teal-600);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.07em;
  line-height: 1.2;
  text-transform: uppercase;
}

.panel-head h2 {
  margin: 4px 0 0;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
}

.workflow-list {
  display: flex;
  flex-direction: column;
}

.workflow-row {
  width: 100%;
  min-height: 68px;
  padding: 12px 14px;
  border: 0;
  border-bottom: 0.5px solid var(--border-soft);
  background: var(--panel-bg);
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.workflow-row:last-child {
  border-bottom: 0;
}

.workflow-row.is-current {
  background: var(--teal-50);
}

.workflow-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
  font-size: 13px;
}

.workflow-row.is-complete .workflow-icon {
  background: var(--green-50);
  color: var(--green-600);
}

.workflow-row.is-current .workflow-icon {
  background: var(--teal-400);
  color: #ffffff;
}

.workflow-copy {
  min-width: 0;
}

.workflow-copy b,
.workflow-copy span {
  display: block;
}

.workflow-copy b {
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
}

.workflow-copy span {
  margin-top: 4px;
  color: var(--text-tertiary);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
}

.workflow-row.is-current .workflow-copy b {
  color: var(--teal-900);
}

.workflow-row.is-current .workflow-copy span {
  color: var(--teal-600);
}

.workflow-badge {
  min-width: 46px;
  padding: 4px 8px;
  border-radius: 999px;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.1;
  white-space: nowrap;
}

.workflow-row.is-complete .workflow-badge {
  background: var(--green-50);
  color: var(--green-600);
}

.workflow-row.is-current .workflow-badge {
  background: var(--teal-400);
  color: var(--teal-50);
}

.snapshot-list {
  padding: 8px 14px 12px;
}

.snapshot-row {
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 400;
}

.snapshot-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.snapshot-label i {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  flex: 0 0 auto;
}

.snapshot-row b {
  font-size: 13px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.snapshot-row.red .snapshot-label i {
  background: var(--red-800);
}

.snapshot-row.red b {
  color: var(--red-800);
}

.snapshot-row.amber .snapshot-label i {
  background: var(--amber-600);
}

.snapshot-row.amber b {
  color: var(--text-primary);
}

.snapshot-row.teal .snapshot-label i {
  background: var(--teal-400);
}

.snapshot-row.teal b {
  color: var(--teal-600);
}

.subtle-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.queue-list {
  padding: 10px;
}

.queue-card {
  width: 100%;
  min-height: 92px;
  margin-bottom: 8px;
  padding: 12px 14px;
  border: 0.5px solid var(--border);
  border-radius: 12px;
  background: var(--panel-bg);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.queue-card:last-child {
  margin-bottom: 0;
}

.queue-card-top,
.queue-card-bottom,
.queue-leading,
.queue-tags,
.queue-time {
  display: flex;
  align-items: center;
}

.queue-card-top,
.queue-card-bottom {
  justify-content: space-between;
  gap: 14px;
}

.queue-leading {
  min-width: 0;
  gap: 8px;
}

.queue-status-icon {
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--text-tertiary);
  font-size: 14px;
  line-height: 1;
}

.queue-status-icon.status-analyzed,
.queue-status-icon.status-proposal_done {
  color: var(--green-600);
}

.queue-status-icon.status-processing,
.queue-status-icon.status-proposal_draft {
  color: var(--amber-600);
}

.queue-title-block {
  min-width: 0;
}

.queue-title-block b {
  display: block;
  overflow: hidden;
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.queue-title-block span {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: var(--text-tertiary);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.queue-state {
  color: var(--text-tertiary);
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.queue-state-analyzed,
.queue-state-proposal_done {
  color: var(--green-600);
}

.queue-state-processing,
.queue-state-proposal_draft {
  color: var(--amber-600);
}

.queue-tags {
  gap: 5px;
  min-width: 0;
  flex-wrap: wrap;
}

.workflow-tag {
  min-width: 34px;
  height: 20px;
  padding: 0 8px;
  border: 0.5px solid transparent;
  border-radius: 999px;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
}

.workflow-tag.collect.is-active {
  border-color: var(--blue-border);
  background: var(--blue-50);
  color: var(--blue-800);
}

.workflow-tag.analyze.is-active {
  border-color: var(--teal-100);
  background: var(--teal-50);
  color: var(--teal-900);
}

.workflow-tag.proposal.is-active {
  border-color: var(--green-border);
  background: var(--green-50);
  color: var(--green-600);
}

.queue-time {
  gap: 5px;
  color: var(--text-tertiary);
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
}

.queue-time i {
  font-size: 10px;
}

.quick-list {
  display: flex;
  flex-direction: column;
}

.quick-row {
  width: 100%;
  min-height: 60px;
  padding: 13px 14px;
  border: 0;
  border-bottom: 0.5px solid var(--border-soft);
  background: transparent;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.quick-row:last-child {
  border-bottom: 0;
}

.quick-row.writing {
  background: var(--teal-50);
}

.quick-icon {
  width: 34px;
  height: 34px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.quick-row.collect .quick-icon {
  background: var(--blue-50);
  color: #185FA5;
}

.quick-row.analyze .quick-icon {
  background: var(--teal-50);
  color: var(--teal-600);
}

.quick-row.writing .quick-icon {
  background: var(--teal-400);
  color: #ffffff;
}

.quick-row.watch .quick-icon {
  background: var(--amber-50);
  color: var(--amber-600);
}

.quick-label {
  overflow: hidden;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-row.writing .quick-label {
  color: var(--teal-900);
}

.quick-pill {
  min-width: 42px;
  padding: 5px 9px;
  border-radius: 999px;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
  font-size: 10px;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
}

.quick-row.collect .quick-pill,
.quick-row.analyze .quick-pill {
  background: var(--blue-50);
  color: var(--blue-800);
}

.quick-row.writing .quick-pill {
  background: var(--teal-400);
  color: var(--teal-50);
}

.quick-row.watch .quick-pill {
  background: var(--amber-50);
  color: var(--amber-600);
}

.week-card {
  padding: 14px;
}

.week-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.week-head span {
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.2;
}

.week-head b {
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 1.1;
  white-space: nowrap;
}

.week-bars {
  height: 36px;
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
  gap: 6px;
}

.week-bar {
  flex: 1 1 0;
  min-width: 0;
  border-radius: 4px 4px 0 0;
  background: var(--teal-100);
  transition: height 0.18s ease, background-color 0.18s ease;
}

.week-bar:nth-child(1) {
  background: var(--teal-50);
}

.week-bar:nth-child(2) {
  background: #ccefe3;
}

.week-bar:nth-child(3) {
  background: var(--teal-100);
}

.week-bar:nth-child(4) {
  background: var(--teal-200);
}

.week-bar:nth-child(5) {
  background: var(--teal-400);
}

.week-bar:nth-child(6) {
  background: #7bd8b8;
}

.week-bar:nth-child(7) {
  background: var(--teal-400);
}

.week-bar.is-today {
  background: var(--teal-600);
}

.day-mon {
  height: 14px;
  background: var(--teal-50);
}

.day-tue {
  height: 20px;
  background: #ccefe3;
}

.day-wed {
  height: 17px;
  background: var(--teal-100);
}

.day-thu {
  height: 27px;
  background: var(--teal-200);
}

.day-fri {
  height: 32px;
  background: var(--teal-400);
}

.day-sat {
  height: 22px;
  background: #7bd8b8;
}

.day-sun {
  height: 36px;
  background: var(--teal-400);
}

.week-labels {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-tertiary);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.2;
}

.week-labels span.is-today {
  color: var(--teal-600);
  font-weight: 500;
}

.state-box {
  min-height: 240px;
  padding: 28px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--text-tertiary);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
}

.state-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-tertiary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.state-box b {
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
}

.inline-primary {
  min-height: 30px;
  padding: 0 12px;
  border: 0.5px solid var(--teal-400);
  border-radius: 8px;
  background: var(--teal-400);
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

@media (max-width: 1260px) {
  .dashboard-body {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .action-column {
    grid-column: 1/-1;
    border-top: 0.5px solid var(--border);
    border-right: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(240px, 280px);
    gap: 14px;
  }
  .action-column .panel + .panel {
    margin-top: 0;
  }
}
@media (max-width: 860px) {
  .hero-banner {
    padding: 24px 18px 0;
  }
  .hero-top {
    flex-direction: column;
    padding-bottom: 20px;
  }
  .hero-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .hero-action {
    flex: 1 1 120px;
  }
  .kpi-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .kpi-cell:nth-child(2) {
    border-right: 0;
  }
  .kpi-cell:nth-child(n+3) {
    border-top: 0.5px solid rgba(255, 255, 255, 0.18);
  }
  .dashboard-body,
  .action-column {
    grid-template-columns: 1fr;
  }
  .dashboard-column {
    border-right: 0;
    border-bottom: 0.5px solid var(--border);
    padding: 16px;
  }
  .dashboard-column:last-child {
    border-bottom: 0;
  }
}
@media (max-width: 900px) {
  .action-column {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .hero-copy h1 {
    font-size: 24px;
  }
  .kpi-strip {
    grid-template-columns: 1fr;
  }
  .kpi-cell,
  .kpi-cell:nth-child(2) {
    border-right: 0;
  }
  .kpi-cell:nth-child(n+2) {
    border-top: 0.5px solid rgba(255, 255, 255, 0.18);
  }
  .queue-card-top,
  .queue-card-bottom {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .workflow-row {
    grid-template-columns: 32px minmax(0, 1fr);
  }
  .workflow-badge {
    grid-column: 2;
    justify-self: flex-start;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public stats: any = {
        totalCrawled: 0,
        activeBids: 0,
        analyzed: 0,
        proposals: 0
    };

    public recentItems: any[] = [];
    public weekSummary: any = {
        total: 0,
        days: [
            { label: '월', count: 0, height: 12, isToday: false },
            { label: '화', count: 0, height: 12, isToday: false },
            { label: '수', count: 0, height: 12, isToday: false },
            { label: '목', count: 0, height: 12, isToday: false },
            { label: '금', count: 0, height: 12, isToday: false },
            { label: '토', count: 0, height: 12, isToday: false },
            { label: '일', count: 0, height: 12, isToday: false },
        ]
    };
    public loading: boolean = true;
    public userName: string = '';
    public greeting: string = '';
    public todayLabel: string = '';

    public async ngOnInit() {
        await this.service.init();
        this.userName = this.service.auth.session?.name || '사용자';
        const hour = new Date().getHours();
        if (hour < 12) this.greeting = '좋은 아침이에요';
        else if (hour < 18) this.greeting = '좋은 오후에요';
        else this.greeting = '좋은 저녁이에요';
        this.todayLabel = new Date().toLocaleDateString('ko-KR', { month: 'long', day: 'numeric', weekday: 'short' });
        await this.loadDashboard();
        await this.service.render();
    }

    public async loadDashboard() {
        try {
            let res = await wiz.call("load");
            if (res.code === 200) {
                this.stats = res.data.stats || this.stats;
                this.recentItems = res.data.recentItems || [];
                this.weekSummary = res.data.weekSummary || this.weekSummary;
            }
        } catch (e) {
            console.error(e);
        }
        this.loading = false;
    }

    public goToCrawl() { this.service.href('/crawl'); }
    public goToAnalysis() { this.service.href('/analysis'); }
    public goToProposal() { this.service.href('/proposal'); }

    public get pipelineCompletion(): number {
        const crawled = this.stats.totalCrawled > 0 ? 1 : 0;
        const analyzed = this.stats.analyzed > 0 ? 1 : 0;
        const proposals = this.stats.proposals > 0 ? 1 : 0;
        return Math.round(((crawled + analyzed + proposals) / 3) * 100);
    }

    public goToDetail(item: any) {
        if (item.status === 'proposal_done' || item.status === 'proposal_draft') {
            this.service.href('/proposal/' + item.notice_no);
        } else {
            this.service.href('/analysis/' + item.notice_no);
        }
    }

    public statusLabel(status: string) {
        const map: any = {
            scraped: '수집됨',
            processing: '분석 중',
            analyzed: '분석 완료',
            proposal_draft: '초안 작성',
            proposal_done: '작성 완료',
        };
        return map[status] || status;
    }

    public statusColor(status: string) {
        const map: any = {
            scraped: 'bg-stone-100 text-stone-600',
            processing: 'bg-amber-50 text-amber-700',
            analyzed: 'bg-blue-50 text-blue-700',
            proposal_draft: 'bg-violet-50 text-violet-700',
            proposal_done: 'bg-emerald-50 text-emerald-700',
        };
        return map[status] || 'bg-stone-100 text-stone-600';
    }

    public statusIcon(status: string) {
        const map: any = {
            scraped: 'bookmark',
            processing: 'clock',
            analyzed: 'check',
            proposal_draft: 'edit',
            proposal_done: 'document',
        };
        return map[status] || 'bookmark';
    }

    public statusIconClass(status: string) {
        const map: any = {
            scraped: 'fa-bookmark',
            processing: 'fa-spinner',
            analyzed: 'fa-circle-check',
            proposal_draft: 'fa-pen-to-square',
            proposal_done: 'fa-file-circle-check',
        };
        return map[status] || 'fa-bookmark';
    }

    public deadlineLabel(deadline: string): string {
        const d = this.parseDate(deadline);
        if (!d) return deadline || '마감일 미정';

        const diff = d.getTime() - new Date().getTime();
        const day = 24 * 60 * 60 * 1000;
        if (diff < 0) return '마감 지남';
        if (diff < day) return '오늘 마감';
        if (diff < day * 2) return '내일 마감';
        if (diff < day * 8) return 'D-' + Math.ceil(diff / day);
        return d.toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
    }

    public isStepDone(status: string, step: string): boolean {
        const statusRank: any = {
            scraped: 1,
            processing: 1,
            analyzed: 2,
            proposal_draft: 3,
            proposal_done: 3,
        };
        const stepRank: any = {
            scraped: 1,
            analyzed: 2,
            proposal: 3,
        };
        return (statusRank[status] || 0) >= (stepRank[step] || 0);
    }

    public pipelineStep(index: number): string {
        const val = [this.stats.totalCrawled, this.stats.analyzed, this.stats.proposals][index] || 0;
        return val > 0 ? 'active' : 'inactive';
    }

    public timeAgo(dateStr: string): string {
        if (!dateStr) return '';
        const now = new Date();
        const d = this.parseDate(dateStr);
        if (!d) return '';
        const diff = Math.floor((now.getTime() - d.getTime()) / 1000);
        if (diff < 60) return '방금 전';
        if (diff < 3600) return Math.floor(diff / 60) + '분 전';
        if (diff < 86400) return Math.floor(diff / 3600) + '시간 전';
        if (diff < 604800) return Math.floor(diff / 86400) + '일 전';
        return d.toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
    }

    private parseDate(dateStr: string): Date | null {
        const value = (dateStr || '').trim();
        if (!value) return null;

        if (/^\d{12,}$/.test(value)) {
            return new Date(
                Number(value.slice(0, 4)),
                Number(value.slice(4, 6)) - 1,
                Number(value.slice(6, 8)),
                Number(value.slice(8, 10)),
                Number(value.slice(10, 12))
            );
        }

        if (/^\d{8}$/.test(value)) {
            return new Date(
                Number(value.slice(0, 4)),
                Number(value.slice(4, 6)) - 1,
                Number(value.slice(6, 8)),
                23,
                59,
                59
            );
        }

        const parsed = new Date(value.includes('T') ? value : value.replace(' ', 'T'));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
}

export default PageDashboardComponent;